/* eslint-disable */
import BASE from '../../../../vue.config.js'
const $ = require('jquery')
import 'prismjs'
import 'prismjs/themes/prism.css'
import Vue from 'vue/dist/vue.js'
import { Validator } from 'vee-validate';

export default{

  data() {
  	return{

  	  idAsignatura:'',
  	  clave:'',
  	  nombreAsignatura:'',
  	  validador: true,
  	  validaClave:'',
  	  validaNombreAsignatura:'',
  	  errorClave:false,
  	  errorNombreAsignatura: false,
  	  errorFileType: false,
  	  isButtonDisabled: false,
  	  isTemarioPreCharged: false,
  	  contieneDocumento: 0,

  	  temario:{
  	  	chargedDoc: {
  	  		isCharged: false,
					name: '',
					file: null,
					eventTarget: null,
					fileLink: ''
  	  	}
  	  },

  	  // Upload files button states
		 	uploadFileCharged:{
		 		onProgress: false,
		 		readyProgess: false,
		 		fileError: null,
		 		text: 'cloud_upload',
		 		style:{
		 			height: null
		 		}
		 	}
		}
	},
 	methods: {
 		deleteChargedFile(documento){
			// Se borra el archivo cargado
			documento.chargedDoc.file = null;
			documento.chargedDoc.isCharged = false;
			documento.chargedDoc.name = '';
			documento.uploadFile = this.uploadFileCharged;

			if (!this.isTemarioPreCharged) {
				// Como no se pueden borrar los objetos de un Filelist
				// se convierte el input a 'text' y se regresa a 'file'
				// de esta manera se borra el archivo que se cargó
				// el evento onDocChargeChanged ya hace efecto si se borra el archivo cargado
				// y se vuelve a subir el mismo archivo
				documento.chargedDoc.eventTarget.type = 'text';
				documento.chargedDoc.eventTarget.type = 'file';
			}
			this.isTemarioPreCharged = false;
			this.contieneDocumento = 0;
 		},
		save(){
			//this.idAsignatura == 0 ? this.saveAsignatura(): this.editar()
			if (this.idAsignatura == 0){
				this.saveAsignatura();
			}else{ 
				this.editar();
			}
		},

		saveAsignatura(){
			var objeto = this.getValoresObjeto();
		
			if (JSON.stringify(objeto) !='{}') {
				let vm = this;
				this.isButtonDisabled = true;
				this.openLoadingButton();

				const formData = new FormData();
				formData.append('objetoAsignatura', JSON.stringify(objeto));
				formData.append('archivo', this.temario.chargedDoc.file);
				$.ajax({
					url: `${BASE.baseUrl}api/AgregarAsignatura`,
					headers:{
						'Authorization': sessionStorage.getItem('token'),
						'pagina': 'asignaturas'
					},
					type:'POST',
					dataType:'json',
					cache: false,
					contentType: false,
					processData: false,
					data:formData,
					success: function(rs){
						console.log(rs)
						vm.showMsg(rs.status);
					},
					error: function (xhr, ajaxOptions, thrownError) {
						console.log('error')
						console.log(xhr.status);
						console.log(thrownError);
					}
				});

			}
		},

		getAsignatura(idAsignatura){
			 
			
			fetch(`${BASE.baseUrl}api/ObtenerAsignatura/${idAsignatura}`, {
        method: 'GET',
        headers: {
        	'Authorization': sessionStorage.getItem('token'),
        	'pagina':'asignaturas'
        }
	    })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {
        if(rs.status == 200){
        	console.log(rs)
          this.clave = rs.result.clave;
				  this.nombreAsignatura = rs.result.nombre;
				  if (rs.result.urlDocumento != '') {
				  	this.contieneDocumento = 1;
				  	this.isTemarioPreCharged = true;
				  	this.temario.chargedDoc.isCharged = true;
				  	this.temario.chargedDoc.name = `Temario_${this.nombreAsignatura}`;
				  	this.temario.uploadFile = this.uploadFileCharged;
				  	this.temario.chargedDoc.fileLink = `${BASE.baseUrl}${rs.result.urlDocumento}`;
				  }
        }
      });
		},

		onDocChargeChanged($event){
			this.errorFileType = false;
			let fileType = event.target.files[0].type
			if (fileType == 'application/pdf'
					|| fileType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
				this.selectedFile = event.target.files[0]
				this.temario.chargedDoc.isCharged = true;
				this.temario.chargedDoc.name = this.selectedFile.name;
				this.temario.chargedDoc.file = this.selectedFile;
				this.temario.chargedDoc.eventTarget = event.target;
				this.temario.uploadFile = this.uploadFileCharged;
				this.contieneDocumento = 1;
			}else{
				this.errorFileType = true;
			}
		},

		openLoadingButton(){
			this.isButtonDisabled = true;
			this.$vs.loading({
				background: 'primary',
				color: '#fff',
				container: '#save-button',
				scale: 0.45
			})
			setTimeout(()=>{
				this.$vs.loading.close('#save-button > .con-vs-loading');
				this.isButtonDisabled = false;
			}, 2000)
		},

		editar(){
			var objeto = this.getValoresObjeto();
			objeto.contieneDocumento = this.contieneDocumento;
			if (JSON.stringify(objeto) !='{}') {

				let vm = this;
				this.isButtonDisabled = true;
				this.openLoadingButton();

				const formData = new FormData();
				formData.append('objetoAsignatura', JSON.stringify(objeto));
				formData.append('archivo', this.temario.chargedDoc.file);
				$.ajax({
					url: `${BASE.baseUrl}api/EditarAsignatura`,
					headers:{
						'Authorization': sessionStorage.getItem('token'),
						'pagina': 'asignaturas'
					},
					type:'POST',
					dataType:'json',
					cache: false,
					contentType: false,
					processData: false,
					data:formData,
					success: function(rs){
						console.log(rs)
						vm.showMsg(rs.status);
					},
					error: function (xhr, ajaxOptions, thrownError) {
						console.log('error')
						console.log(xhr.status);
						console.log(thrownError);
					}
				});

			}
		},

		//MUESTRA EN MENSAJE DE LA RESUESTA
		showMsg(idResupesta){
		
			switch(idResupesta){
				case 200:
					this.$vs.notify({color:'success',title:'Exitoso',text:'La asignatura se ha guardado correctamente.'})
					setTimeout(()=>{
						this.$router.push('/asignaturas');
					},1000); 
					break;
				case 207:
					this.$vs.notify({color:'warning',title:'Alerta',text:'Datos repetidos'})
					break;
				case 427:
					this.$vs.notify({color:'warning',title:'Alerta',text:'No tiene permisos para esta acción.'})
					break;
				case 429:
					this.$vs.notify({color:'warning',title:'Alerta',text:'Datos incorrectos'})
					break;
				case 500:
					this.$vs.notify({color:'danger',title:'Error',text:'Ha ocurrido un error. Favor de ponerse en contacto con el administrador.'})
					break;
				default:
					this.$vs.notify({color:'warning',title:'Alerta',text:'Favor de ponerse en contacto con el administrador.'})
					break;
			}
		},

		//OBTENMOS LOS VALORES DEL FORMULARIO (SE USA PARA GUARDA Y EDITAR)
		getValoresObjeto(){

			this.validarValores();
			var objeto = {};
			if (this.validador == true){
				objeto = {
					'idAsignatura':this.idAsignatura,
					'clave':this.clave,
					'nombre':this.nombreAsignatura
				}
			}
			return objeto	
		},

		validarValores(){
			if (this.clave == ''){
				this.validador = false;
				this.errorClave = true;
				this.validaClave = 'El campo Clave es obligatorio.'}
			if (this.nombreAsignatura == ''){
				this.validador = false;
				this.errorNombreAsignatura = true;
				this.validaNombreAsignatura = 'El campo Nombre es obligatorio.' }
		}
	},

  created() {
  	this.idAsignatura = this.$route.params.idAsignatura;
  	if (this.idAsignatura !=0){ this.getAsignatura(this.idAsignatura);}
  },
  updated(){
  	if (this.clave != ''){
  		this.validaClave = '';
  		this.validador = true;
  		this.errorClave = false; 
  }
  	if (this.nombreAsignatura != ''){
  		this.validaNombreAsignatura = '';
  		this.validador = true;
  		this.errorNombreAsignatura = false;
  	}
  }
}
